/* VizTooltip — the one hover tooltip primitive for the read-side visuals.
 * Fixed-position (escapes the scrolling pane), pointer-events: none, full
 * when/with payloads rendered pre-wrapped in mono. */
import React, {
    useCallback,
    useState
} from 'react';
import './visuals.css';

export interface VizTipState {
    x: number;
    y: number;
    title: string;
    body?: string;
}

export interface VizTipApi {
    tip: VizTipState | null;
    /** Anchor at the pointer-enter position. */
    show: (e: {
        clientX: number;
        clientY: number;
    }, title: string, body?: string) => void;
    hide: () => void;
}

export function useVizTooltip(): VizTipApi {
    const [tip, setTip] = useState<VizTipState | null>(null);
    const show = useCallback((e: {
        clientX: number;
        clientY: number;
    }, title: string, body?: string) => {
        setTip({
            x: e.clientX,
            y: e.clientY,
            title,
            body
        });
    }, []);
    const hide = useCallback(() => setTip(null), []);
    return {
        tip,
        show,
        hide
    };
}

export default function VizTooltip({
    tip
}: {
    tip: VizTipState | null;
}) {
    if (!tip) return null;
    // Clamp so long bodies never run off the right/bottom viewport edge.
    const left = Math.min(tip.x + 14, Math.max(8, window.innerWidth - 480));
    const top = Math.min(tip.y + 12, Math.max(8, window.innerHeight - 340));
    return (
        <div className="aps-viz-tip" style={{
            left,
            top
        }}>
            <p className="aps-viz-tip-title">{tip.title}</p>
            {tip.body ? <pre className="aps-viz-tip-body">{tip.body}</pre> : null}
        </div>
    );
}
